import { ReceiptText } from "lucide-react";
import { NavigationLinkProps } from "../../providers/Router";
import IRP5DirectoryPage from "./pages/IRP5DirectoryPage";
import FeatureFlags from "../../common/feature-flagging/FeatureFlags";
import IRP5IssuesPage from "./pages/IRP5IssuesPage";
import { FEATURE_IRP5S } from "../../utils/UserAccessControlUtils";

const IRP5Router: NavigationLinkProps[] = [
  {
    id: "1d790fe5-54e5-47da-981b-706db1b489de",
    title: "IRP5s",
    description: "",
    path: "/irp5s",
    auth: true,
    sidebar: true,
    secondarySidebar: false,
    icon: ReceiptText,
    component: IRP5DirectoryPage,
    requiredFeature: FEATURE_IRP5S,
    requiredPermissions: ["ANY"],
    requiredFeatureFlag: FeatureFlags.EMPLOYER_PORTAL_IRP5_VIEW,
    isFeatureFlagged: true,
  },
  {
    id: "42fb73fd-c181-4e65-923d-a8269273fcaf",
    title: "IRP5s",
    description: "",
    path: "/irp5s/:id/errors",
    auth: true,
    sidebar: false,
    secondarySidebar: false,
    component: IRP5IssuesPage,
    requiredFeature: FEATURE_IRP5S,
    requiredPermissions: ["ANY"],
    requiredFeatureFlag: FeatureFlags.EMPLOYER_PORTAL_IRP5_VIEW,
    isFeatureFlagged: true,
  },
];

export default IRP5Router;
